var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTodoListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.780029 44.1484C0.780029 33.2062 0.76762 22.2642 0.785717 11.3222C0.793989 6.3121 3.99243 2.22594 8.77252 1.10311C9.64296 0.898578 10.5623 0.82343 11.4593 0.822139C23.8028 0.804578 36.1462 0.815683 48.4894 0.806644C51.7031 0.80432 54.4165 1.92664 56.5835 4.30479C61.9336 10.1764 67.2845 16.0476 72.6137 21.9381C74.4233 23.9384 75.2501 26.3318 75.2472 29.0247C75.2405 35.0606 75.254 41.0965 75.2315 47.1324C75.2291 47.7581 75.3907 48.0688 75.9939 48.3559C84.0701 52.2009 88.6633 60.8918 87.4397 69.9284C86.2712 78.5599 79.3914 85.7096 70.6515 87.2061C68.6314 87.5519 66.5384 87.5725 64.4787 87.5759C46.8364 87.6027 29.1935 87.596 11.5511 87.5888C5.22455 87.5862 0.785199 83.1248 0.781839 76.7806C0.775634 65.9032 0.779771 55.0258 0.780029 44.1484ZM50.4231 5.09268C49.6432 5.02993 49.002 4.93361 48.3604 4.93309C36.0805 4.92431 23.8004 4.91889 11.5204 4.93102C7.52877 4.9349 4.90579 7.56354 4.90424 11.5603C4.89623 33.3175 4.89649 55.0743 4.90424 76.8315C4.90553 80.8324 7.52334 83.4667 11.5126 83.4704C25.5375 83.4827 39.5626 83.4758 53.5877 83.4722C53.8157 83.4722 54.0437 83.4262 54.4506 83.3823C50.3135 80.1104 47.7939 76.0185 46.6846 71.0778C41.896 71.0778 37.2123 71.0817 32.5287 71.0724C32.0804 71.0714 31.6169 71.0481 31.1877 70.9335C30.3201 70.7016 29.7307 69.8577 29.7408 68.9747C29.7509 68.0817 30.3452 67.2719 31.2255 67.0451C31.6254 66.9421 32.0551 66.9194 32.4713 66.9186C36.7046 66.9101 40.9379 66.9132 45.1712 66.9132C45.5169 66.9132 45.8625 66.9132 46.2622 66.9132C46.4729 60.4011 48.9069 55.0178 53.8953 50.9458C58.9034 46.8579 64.7047 45.5718 71.0429 46.6363C71.0827 46.4331 71.1171 46.3404 71.1171 46.2471C71.1199 40.4364 71.131 34.626 71.1132 28.8155C71.108 27.1331 70.4666 25.689 69.3268 24.4412C64.6434 19.3151 59.9727 14.1776 55.3069 9.03578C55.121 8.83125 55.0305 8.54021 54.8953 8.2892C54.7906 8.3677 54.6856 8.44621 54.5807 8.52472C54.5688 8.64118 54.5463 8.75765 54.5463 8.87412C54.5445 13.6839 54.5303 18.4939 54.5535 23.3034C54.5608 24.8174 55.4012 25.5945 56.9384 25.6015C59.459 25.6126 61.9799 25.5999 64.5005 25.6066C66.0247 25.6105 66.9179 26.3571 66.9406 27.624C66.965 28.9454 66.0826 29.7122 64.4927 29.7181C62.0044 29.7277 59.5159 29.7295 57.0276 29.7186C52.9949 29.7016 50.4278 27.1347 50.4239 23.1174C50.4187 17.5004 50.4226 11.8837 50.4226 6.26691C50.4231 5.91777 50.4231 5.56862 50.4231 5.09268ZM67.5151 83.4523C76.8997 83.0528 83.8778 75.3538 83.4851 66.3352C83.0735 56.8789 75.2772 49.91 65.9412 50.4239C56.9371 50.9192 49.9273 58.8271 50.4438 67.9066C50.9487 76.7837 58.799 83.9324 67.5151 83.4523Z",
    fill: "url(#paint0_linear_307_96)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6042 64.8314C26.6042 65.9609 26.6464 67.0928 26.5952 68.2198C26.4998 70.3157 24.8253 72.0139 22.7209 72.0738C20.493 72.1365 18.2601 72.1412 16.0327 72.0699C13.9348 72.003 12.2562 70.2857 12.1975 68.1826C12.1383 66.0539 12.1518 63.9216 12.1823 61.7919C12.2161 59.4483 13.8208 57.7359 16.1679 57.6419C18.2971 57.5567 20.4346 57.5639 22.5648 57.6368C24.9582 57.7184 26.5623 59.43 26.6138 61.8291C26.6352 62.8292 26.6174 63.8304 26.6174 64.8311C26.613 64.8314 26.6086 64.8314 26.6042 64.8314ZM16.3535 61.82C16.3535 63.918 16.3535 65.9023 16.3535 67.9006C18.4259 67.9006 20.4374 67.9006 22.4407 67.9006C22.4407 65.8346 22.4407 63.847 22.4407 61.82C20.3922 61.82 18.4021 61.82 16.3535 61.82Z",
    fill: "url(#paint1_linear_307_96)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1813 23.492C12.1813 22.4267 12.15 21.3605 12.1878 20.2965C12.2658 18.0888 13.9522 16.3699 16.1452 16.3206C18.3093 16.2718 20.476 16.2723 22.6401 16.3204C24.8347 16.3689 26.543 18.0816 26.5988 20.2911C26.6518 22.388 26.641 24.4875 26.6105 26.5852C26.5753 28.9771 24.949 30.6817 22.5493 30.7646C20.4514 30.8369 18.3471 30.8359 16.2489 30.7651C13.8498 30.6843 12.2307 28.9765 12.179 26.5912C12.1567 25.5587 12.1751 24.5252 12.1751 23.4923C12.1769 23.492 12.1792 23.492 12.1813 23.492ZM16.3453 26.5522C18.4086 26.5522 20.4191 26.5522 22.4465 26.5522C22.4465 24.4976 22.4465 22.5125 22.4465 20.4923C20.3806 20.4923 18.3675 20.4923 16.3453 20.4923C16.3453 22.5502 16.3453 24.5381 16.3453 26.5522Z",
    fill: "url(#paint2_linear_307_96)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.384 51.4048C18.2856 51.4045 17.1858 51.4414 16.0892 51.3965C13.9186 51.3077 12.2473 49.6526 12.1945 47.48C12.1413 45.287 12.14 43.0904 12.1961 40.8974C12.2517 38.7316 13.9362 37.06 16.1117 37.0073C18.307 36.9538 20.506 36.9523 22.7012 37.0088C24.8696 37.0643 26.5412 38.7445 26.5955 40.9199C26.6501 43.1129 26.6516 45.3095 26.5942 47.5022C26.5374 49.6694 24.8546 51.3139 22.6787 51.3981C21.5823 51.4407 20.4825 51.4053 19.384 51.4048ZM22.4377 47.2819C22.4377 45.1858 22.4377 43.1769 22.4377 41.1709C20.3646 41.1709 18.3533 41.1709 16.3715 41.1709C16.3715 43.2508 16.3715 45.2607 16.3715 47.2819C18.4151 47.2819 20.3807 47.2819 22.4377 47.2819Z",
    fill: "url(#paint3_linear_307_96)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0184 29.7205C36.7237 29.7205 34.4291 29.7301 32.1344 29.7172C30.6694 29.7086 29.7167 28.867 29.7376 27.6412C29.7586 26.4057 30.7045 25.6088 32.1882 25.607C36.7775 25.6016 41.3668 25.6003 45.9561 25.6078C47.4433 25.6104 48.3378 26.4148 48.3247 27.6959C48.3117 28.945 47.4576 29.7071 45.9992 29.7164C43.6723 29.7316 41.3453 29.7205 39.0184 29.7205Z",
    fill: "url(#paint4_linear_307_96)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9822 50.3981C36.6229 50.3975 34.2636 50.4112 31.9046 50.3916C30.8532 50.3828 30.1223 49.8374 29.8532 48.9374C29.5815 48.0297 29.824 47.2426 30.5856 46.7158C30.9566 46.4594 31.479 46.3067 31.934 46.3039C36.6844 46.275 41.4353 46.2739 46.1859 46.2936C47.4873 46.299 48.3102 47.1174 48.3246 48.2996C48.3399 49.5138 47.4775 50.3795 46.1567 50.3921C43.7651 50.4154 41.3735 50.3986 38.9822 50.3981Z",
    fill: "url(#paint5_linear_307_96)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9021 21.4872C35.3194 21.4875 33.7367 21.5022 32.1543 21.4831C30.6843 21.4655 29.7376 20.6304 29.7407 19.4001C29.7438 18.1665 30.6856 17.3355 32.1628 17.3285C35.3926 17.313 38.6225 17.3112 41.852 17.3301C43.2752 17.3383 44.1834 18.152 44.2097 19.3604C44.2371 20.6074 43.3096 21.4612 41.8435 21.4816C40.1969 21.5051 38.5494 21.487 36.9021 21.4872Z",
    fill: "url(#paint6_linear_307_96)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9596 42.1161C35.3128 42.1166 33.6655 42.1323 32.0189 42.1119C30.6415 42.0949 29.7083 41.2187 29.739 40.023C29.769 38.8465 30.6772 38.0129 32.0068 38.0072C35.3327 37.9927 38.6588 37.9917 41.9847 38.0082C43.2931 38.0149 44.2075 38.8873 44.2116 40.0594C44.216 41.236 43.3205 42.0905 41.9969 42.1096C40.318 42.1336 38.6387 42.1156 36.9596 42.1161Z",
    fill: "url(#paint7_linear_307_96)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9444 58.6824C38.5912 58.6819 40.2383 58.6695 41.8848 58.686C43.2932 58.7002 44.2074 59.517 44.2113 60.7233C44.2151 61.9298 43.2816 62.7882 41.9029 62.7933C38.6093 62.8055 35.3157 62.807 32.0222 62.7925C30.6473 62.7866 29.7164 61.9047 29.7407 60.6936C29.7642 59.5245 30.6652 58.7046 32.0041 58.6875C33.6506 58.6666 35.2976 58.6826 36.9444 58.6824Z",
    fill: "url(#paint8_linear_307_96)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7527 70.0803C66.8959 67.5126 68.9576 65.0425 71.0193 62.5727C71.8665 61.5578 72.6994 60.5302 73.5668 59.5329C74.467 58.4979 75.7304 58.3576 76.6378 59.1523C77.5372 59.9402 77.601 61.1232 76.7298 62.1729C73.3737 66.218 70.009 70.2561 66.6252 74.2785C65.6131 75.4817 64.4027 75.5196 63.2835 74.4172C61.3071 72.4703 59.3449 70.5095 57.3965 68.535C56.4376 67.5629 56.4042 66.399 57.2514 65.5275C58.1025 64.6518 59.3517 64.6825 60.34 65.6535C61.7893 67.0769 63.2096 68.5293 64.7527 70.0803Z",
    fill: "url(#paint9_linear_307_96)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_96",
    x1: 43.3609,
    y1: -0.52436,
    x2: 44.3927,
    y2: 87.7944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_307_96",
    x1: 18.6363,
    y1: -0.235831,
    x2: 19.6682,
    y2: 88.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_307_96",
    x1: 19.1154,
    y1: -0.241556,
    x2: 20.1473,
    y2: 88.0772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_307_96",
    x1: 18.8754,
    y1: -0.23831,
    x2: 19.9072,
    y2: 88.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_307_96",
    x1: 38.7015,
    y1: -0.470029,
    x2: 39.7334,
    y2: 87.8487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_307_96",
    x1: 38.4642,
    y1: -0.4669,
    x2: 39.496,
    y2: 87.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_307_96",
    x1: 36.7432,
    y1: -0.447483,
    x2: 37.775,
    y2: 87.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_307_96",
    x1: 36.5006,
    y1: -0.444468,
    x2: 37.5325,
    y2: 87.8742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_307_96",
    x1: 36.2594,
    y1: -0.440997,
    x2: 37.2912,
    y2: 87.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_307_96",
    x1: 66.2415,
    y1: -0.791392,
    x2: 67.2733,
    y2: 87.5273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5506"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoListIcon);
export default __webpack_public_path__ + "static/media/todoListIcon.ce513a4389e62a933b1cb7f561542bdf.svg";
export { ForwardRef as ReactComponent };